// Sanitize user-facing / model-generated text before rendering to prevent stray
// markup injection. The app renders text via React (auto-escaped), but long model
// output is also shown in the dev panel, so we clip and strip control characters.

// Strip control characters without writing literal control chars in the source
// (avoids the `no-control-regex` lint rule).
const CTRL_RE = new RegExp(`[${String.fromCharCode(0)}-${String.fromCharCode(31)}${String.fromCharCode(127)}]`, 'g');

export function sanitizeText(input: unknown, maxLen = 280): string {
  if (typeof input !== 'string') return '';
  return input
    .replace(CTRL_RE, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, maxLen);
}

export function sanitizeTags(input: unknown, max = 12): string[] {
  if (!Array.isArray(input)) return [];
  const seen = new Set<string>();
  const out: string[] = [];
  for (const t of input) {
    if (typeof t !== 'string') continue;
    const clean = t.toLowerCase().replace(/[^a-z0-9_-]/g, '').slice(0, 32);
    if (clean.length === 0 || seen.has(clean)) continue;
    seen.add(clean);
    out.push(clean);
    if (out.length >= max) break;
  }
  return out;
}
